module.exports = "/_next/static/images/text-blue-num-1-e218f7f4.png";